export enum ExportWizardType {
    PANORAMA = 1,
    COLLAGE_OFFICE,
    SCANS,
}

export interface FormatWizardType {
    keyText: string;
    id: number;
    checked: boolean;
    isVisible?: boolean;
    disabled?: boolean;
}

export interface TableData {
    name: string;
    parentName?: string;
    format?: string[];
    options?: string[];
}

export enum WizardSteps {
    SELECT_TYPE = 0,
    SELECT_DATA_TO_EXPORT,
    SUMMARY,
}
